YP.TypeProduct = function() {
    return {
        init: function(){
            function handleTypeProductQuantity(input) {
                var val           = input.val(),
                    typeProductId = input.data('id'),
                    sum           = 0,
                    max           = Math.abs($(".max-container .max[data-id=" + typeProductId + "]").data('max')),
                    currentMax    = input.attr('max'),
                    left          = 0;

                $(".ypl-store_product_price_input[max][data-id=" + typeProductId + "]").each(function(){
                    sum += Math.abs($(this).val());
                });

                left = max - sum;
                $(".ypl-store_product_price_input[max][data-id=" + typeProductId + "]").each(function(){
                    currentVal = Math.abs($(this).val());
                    if((currentVal + left) <= max) {
                        $(this).attr('max', left + currentVal);
                    } else {
                        $(this).attr('max', left);
                    }
                });

                if(left <= max && left >=0) {
                    $(".max-container .max[data-id=" + typeProductId + "]").text(left);
                }
            };

            $(".ypl-store_product_price_quantity_add").live("click", function(e) {
                number = $(this).data('number');
                var input = $(".ypl-store_product_price_input[data-number=" + number + "]");

                if (!input.attr("max") || Math.abs(input.attr("max")) > Math.abs(input.val())) {
                    input.val(Math.abs(input.val()) + 1);
                    handleTypeProductQuantity(input);
                }
            });

            $(".ypl-store_product_price_quantity_remove").live("click", function(e) {
                number = $(this).data('number');
                var input = $(".ypl-store_product_price_input[data-number=" + number + "]");
                if (Math.abs(input.val()) > 0) {
                    input.val(Math.abs(input.val()) - 1);
                    handleTypeProductQuantity(input);
                }
            });
        }
    };
};
